import { render, staticRenderFns } from "./folders-filters-modal.vue?vue&type=template&id=01060618&scoped=true"
import script from "./folders-filters-modal.vue?vue&type=script&lang=js"
export * from "./folders-filters-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01060618",
  null
  
)

export default component.exports